import type React from 'react'

import { Children, cloneElement, useState } from 'react'
import { PopupPortal } from 'blocks/PopupPortal'
import { useSSRLazyLoading } from 'utils/hooks'
import { PopupAdapterSC } from './PopupAdapter.styled'

export interface IPopupAdapter {
  children?: React.ReactNode
  withUsingPopup?: boolean
  withUsingPortal?: boolean
  wrapperId?: string
  withoutToggle?: boolean // if TRUE open, close functions and popup condition comes from skin
  isPopupOpen?: boolean
}

export const PopupAdapter = ({
  children,
  withUsingPopup = true,
  withUsingPortal = false,
  wrapperId,
  withoutToggle,
  isPopupOpen,
}: IPopupAdapter) => {
  const [openPopup, setOpenPopup] = useState<boolean>(!!isPopupOpen)
  const isShowComponent = useSSRLazyLoading()

  // e is optional because onClose event have error with preventDefault method. TODO: fix it during popup refactor
  const toggleOpenPopup = (e?: React.MouseEvent) => {
    e?.preventDefault()
    e?.stopPropagation()
    return setOpenPopup(!openPopup)
  }
  const components = Children.toArray(children)
  const ActionComponent = ({ children }: any) => {
    return withoutToggle
      ? children
      : cloneElement(children, {
          onClick: withUsingPopup ? toggleOpenPopup : null,
        })
  }
  const PopupComponent = ({ children }: any) => {
    return withoutToggle
      ? children
      : cloneElement(children, { onClose: toggleOpenPopup })
  }
  return (
    <>
      {components.length === 2 && withUsingPortal ? (
        <PopupAdapterSC>
          <ActionComponent>{components[0]}</ActionComponent>
          {isShowComponent && (
            <PopupPortal wrapperId={wrapperId}>
              {openPopup && <PopupComponent>{components[1]}</PopupComponent>}
            </PopupPortal>
          )}
        </PopupAdapterSC>
      ) : (
        components.length === 2 && (
          <PopupAdapterSC>
            <ActionComponent>{components[0]}</ActionComponent>
            {openPopup && <PopupComponent>{components[1]}</PopupComponent>}
          </PopupAdapterSC>
        )
      )}
    </>
  )
}

PopupAdapter.displayName = 'PopupAdapter'
